import "@arco-design/web-react/es/InputNumber/style";
import _InputNumber from "@arco-design/web-react/es/InputNumber";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useDebounceEffect } from 'ahooks';
export function LxInputNumber(props) {
  useDebounceEffect(() => {
    if (props.value) {
      props?.onChange?.(props.value, props.value, props?.name);
    }
  }, [props.value], {
    wait: 10
  });
  return /*#__PURE__*/React.createElement(_InputNumber, _extends({}, props, {
    hideControl: true,
    value: props.value,
    precision: props.precision,
    onChange: value => props?.onChange?.(value, value, props?.name, true)
  }));
}